import { cn } from '@costar-ui/cosmos';
import React__default from 'react';

/**
 * @description
 * **A molecule component that returns the composition of a CategoryBar and ArticleTitle**
 *
 * Requires following element props
 * >- articleTitleElement
 * >- categoryBarElement
 * >- articlePreviewElement
 *
 * @example
 * <ArticlePromo
 *    articleTitleElement={featuredArticleTitle}
 *    categoryBarElement={categoryBarElement}
 * />
 */
var ArticlePromo = function ArticlePromo(props) {
  var articleTitleElement = props.articleTitleElement,
    categoryBarElement = props.categoryBarElement,
    articlePreviewElement = props.articlePreviewElement,
    articlePromoContainerStyle = props.articlePromoContainerStyle;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn("flex flex-col gap-1", articlePromoContainerStyle)
  }, categoryBarElement, articleTitleElement, articlePreviewElement);
};

export { ArticlePromo };
//# sourceMappingURL=article-promo.esm.js.map
